import { useContext } from "react";

import { DirectDocumentBudgetContext } from "./DirectDocumentBudgetContext";
import type { DirectDocumentBudget } from "./useDirectDocumentBudget";

export function useDirectDocumentBudgetContext(): DirectDocumentBudget {
    const context = useContext(DirectDocumentBudgetContext);
    if (context === null) {
        throw new Error(
            "useDirectDocumentBudgetContext must be used inside a <DirectDocumentBudgetProvider>"
        );
    }
    return context;
}
